import http, { httpWithoutMiddleware } from '@/api/http'

import {
  TGetCitiesByUfParams,
  TGetCitiesByUfResponse,
  TGetEducationStagesResponse,
  TGetPredictionsYearsResponse,
  TGetPredictionsBaseYearsResponse,
  TGetPredictionVersionsParams,
  TGetPredictionVersionsResponse,
  TGetCensusYearsResponse,
  TGetComparativeYearsResponse,
  TGetSchoolsByCityParams,
  TGetSchoolsByCityResponse,
} from './types'

export const getEducationStages = async () => {
  const response = await httpWithoutMiddleware.get<TGetEducationStagesResponse>(
    '/auxiliary/education_stages/'
  )

  return response.data
}

export const getPredictionsYears = async () => {
  const response = await http.get<TGetPredictionsYearsResponse>(
    '/auxiliary/prediction_years/'
  )

  return response.data
}

export const getPredictionVersions = async ({
  nuCensusYear,
}: TGetPredictionVersionsParams) => {
  const response = await http.get<TGetPredictionVersionsResponse>(
    '/auxiliary/prediction_versions/',
    { params: { nu_census_year: nuCensusYear } }
  )

  return response.data
}

export const getPredictionsBaseYears = async () => {
  const response = await http.get<TGetPredictionsBaseYearsResponse>(
    '/auxiliary/prediction_base_years/'
  )

  return response.data
}

export const getCensusYears = async () => {
  const response = await http.get<TGetCensusYearsResponse>(
    '/auxiliary/census_years/'
  )

  return response.data
}

export const getComparativeYears = async () => {
  const response = await http.get<TGetComparativeYearsResponse>(
    '/auxiliary/comparative_years/'
  )

  return response.data
}

export const getCitiesByUf = async ({ sgUf }: TGetCitiesByUfParams) => {
  const response = await http.get<TGetCitiesByUfResponse>(
    '/auxiliary/cities/',
    {
      params: {
        sgUf,
      },
    }
  )

  return response.data
}

export const getSchoolsByCity = async ({ noCity }: TGetSchoolsByCityParams) => {
  const response = await http.get<TGetSchoolsByCityResponse>(
    '/auxiliary/schools/',
    {
      params: {
        co_city: noCity,
      },
    }
  )

  return response.data
}
